import { render, staticRenderFns } from "./mindMap.vue?vue&type=template&id=cdc0bfa8&scoped=true"
import script from "./mindMap.vue?vue&type=script&lang=js"
export * from "./mindMap.vue?vue&type=script&lang=js"
import style0 from "./mindMap.vue?vue&type=style&index=0&id=cdc0bfa8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdc0bfa8",
  null
  
)

export default component.exports